<template>
  <p>Notebook {{ n }}</p>
</template>

<script>
export default {
	props: ['n']
}
</script>

<style>

</style>